import React from 'react';
import { useLogout } from '../hooks';

export const withUseLogout = (Component: typeof React.Component) => {
  return (props: Record<string, unknown>) => {
    const logout = useLogout();
    return <Component {...props} logout={logout} />;
  };
};
